import * as React from "react";
export class Tooltip extends React.Component {
    render() {
        return (this.props.shouldShow &&
            React.createElement("div", { className: "rj-league-list__tooltip-message-holder", "data-uat": "div-league-list-tooltip-message-holder" },
                React.createElement("span", { className: "rj-league-list__tooltip-message-content", "data-uat": "div-league-list-tooltip-message-content" }, this.props.message)));
    }
}
//# sourceMappingURL=Tooltip.js.map